import styled from 'styled-components';
import { colorPrimaryLight, colorWhite, mediaSm } from 'theme/theme-helper-selectors';

export const EquipmentWrapper = styled.div`
    padding: 60px 0;
    position: relative;
    z-index: 15;
`;

export const Title = styled.h3`
    font-size: 72px;
    line-height: 72px;
    font-weight: 500;
    margin: 0 0 40px 0;

    @media (${mediaSm}) {
        display: none;
    }
`;

export const DesktopGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 24px;

    @media (${mediaSm}) {
        display: none;
    }
`;

export const MobileAccordionContainer = styled.div`
    display: none;

    @media (${mediaSm}) {
        display: block;
    }
`;

export const Card = styled.div`
    background: ${colorWhite};
    border-radius: 8px;
    padding: 24px;
    border: 1px solid #d9dde2;
    display: flex;
    flex-direction: column;

    &:nth-child(1) {
        grid-column: span 2;
        grid-row: span 2;
    }

    &:nth-child(2) {
        grid-column: span 2;
        grid-row: span 2;
    }

    &:nth-child(3) {
        grid-column: span 2;
        grid-row: span 1;
    }

    &:nth-child(4) {
        grid-column: span 2;
        grid-row: span 1;
    }

    &:nth-child(5) {
        grid-column: span 3;
        grid-row: span 1;
    }

    &:nth-child(6) {
        grid-column: span 3;
        grid-row: span 1;
    }
`;

export const CardIcon = styled.img`
    width: 80px;
    height: 80px;
    object-fit: contain;
    flex-shrink: 0;

    @media (${mediaSm}) {
        width: 50px;
        height: 50px;
    }
`;

export const CardHeader = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 25px;
    margin-bottom: 20px;
`;

export const CardTitle = styled.h4`
    font-size: 28px;
    line-height: 28px;
    font-weight: 500;
    white-space: pre-line;

    @media (${mediaSm}) {
        font-size: 22px;
        line-height: 24px;
    }
`;

export const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const ListItem = styled.li`
    font-size: 20px;
    line-height: 24px;
    position: relative;
    padding-left: 16px;
    color: inherit;

    @media (${mediaSm}) {
        font-size: 14px;
        line-height: 20px;
    }

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 9px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: ${colorPrimaryLight};

        @media (${mediaSm}) {
            top: 7px;
        }
    }
`;

export const AccordionTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;
